module.exports = "Please select a Custom Form to Add\r\n\r\n<select\r\n    class=\"form-control\"\r\n    ng-options=\"(item.name) for item in customForms track by item.customFormId\"\r\n    ng-model=\"selectedForm\">\r\n</select>"


//////////////////
// WEBPACK FOOTER
// ./client/app/common/templates/customForms/addCustomFormTemplate.html
// module id = 1953
// module chunks = 0